<template>
    <div class="approve_admin_more_settings">
        <div class="approve_admin_more_settings_wrap">
            <el-form :model="moreSettingForm"
                     :rules="moreSettingFormRules"
                     label-position="top"
                     size="small">
                <div class="settings_title">
                    <span>提交人权限</span>
                </div>
                <div class="settings_form_wrap">
                    <el-form-item class="left_border_form" label="">
                        <el-checkbox @change="haveEditedBefore()" :disabled="disabled_allow_undo_pending.indexOf(approvalType) > -1" :false-label="0" :true-label="1" v-model="moreSettingForm.allow_undo_pending">允许撤销审批中的申请（配置前已发起的申请不生效）</el-checkbox>
                        <p class="hint">任意审批节点通过后，提交人仍可撤销申请</p>
<!--                        <el-checkbox :false-label="0" :true-label="1" v-model="moreSettingForm.is_undo_ing">只允许撤销 <el-input-number style="width: 84px" size="mini" :controls="false"></el-input-number> 天内通过的审批（配置前已通过的审批不可撤销）</el-checkbox>-->
<!--                        <p class="hint">天内通过的审批（配置前已通过的审批不可撤销）</p>-->
<!--                        <el-checkbox :false-label="0" :true-label="1" v-model="moreSettingForm.allow_substitute">允许代他人提交</el-checkbox>-->
<!--                        <p class="hint">代提人和实际提交人都需要在审批发起范围内，提交后共享审批单后续状态（审批流程按照实际提交人的流程）</p>-->
                    </el-form-item>
                </div>

                <div class="settings_title">
                    <span>审批人设置</span>
                </div>
                <div class="settings_form_wrap">
                    <el-form-item class="left_border_form" label="">
<!--                        <el-checkbox @change="haveEditedBefore()"  :false-label="0" :true-label="1" v-model="moreSettingForm.allow_batch_processing">允许审批人批量处理</el-checkbox>-->
<!--                        <p class="hint">勾选后，审批人在处理此类型审批时，可一次批量处理多个任务</p>-->
                        <el-checkbox @change="haveEditedBefore()"  :false-label="0" :true-label="1" v-model="moreSettingForm.enable_quick_approval">开启快捷审批</el-checkbox>
                        <p class="hint">开启后可进行快速审批处理</p>
                    </el-form-item>
                </div>

                <div class="settings_title">
                    <span>审批人去重 <i class="dec">（同一审批人在流程中重复出现时）</i></span>
                </div>
                <div class="settings_form_wrap">
                    <el-form-item class="left_border_form" label="" prop="approver_duplication_type">
                        <el-radio-group @change="haveEditedBefore()"  class="unique_type_radio_group" v-model="moreSettingForm.approver_duplication_type">
                            <div class="mb_16"><el-radio :label="1">仅审批一次，后续重复节点自动同意</el-radio></div>
                            <div class="mb_16"><el-radio :label="2">仅连续节点可自动通过</el-radio></div>
                            <div class="mb_16"><el-radio :label="3">每个节点都需审批，不可跳过</el-radio></div>
                            <div class="mb_16"><el-radio :label="4">仅审批一次，审批最后一个节点</el-radio></div>
                        </el-radio-group>
                        <p class="hint_text"  >审批加签/回退/转交的情况，去重失效，不会自动同意，均需处理审批。</p>
                    </el-form-item>
                </div>

                <div class="settings_title" v-if="approvalType == ''">
                    <span>审批概览区字段设置
                        <el-popover placement="top-start" title="" trigger="hover" width="332">
                            <div>
                                <p style="margin-bottom: 8px;font-size: 12px;color: rgba(51, 51, 51, 1);line-height: 18px">选择控件进行设置，设置后的数据将在审批中心概览展示，最多设置3个字段</p>
                                <img alt="" src="https://download.hecoos.com/enlightv/2024-46/a936ee80968c8632379763e6aaa11868.png" width="300">
                            </div>
                            <span class="handle_icon_wrap" slot="reference">
                                 <i class=" iconfont icon-bangzhuzhongxin" style="font-weight: 400"></i>
                            </span>
                        </el-popover>
                    </span>
                </div>
                <div class="settings_form_wrap">
                    <el-form-item class="left_border_form" label="" prop="overview_fields" v-if="moreSettingForm.overview_fields &&  moreSettingForm.overview_fields.length">
                        <ul class="option_wrap">
                            <draggable animation="300" handle=".mover" v-model="moreSettingForm.overview_fields">
                                <li :key="key" v-for="(item,key) in moreSettingForm.overview_fields">
                                    <i class="iconfont icon-a-move mover"></i>
                                    <el-select placeholder="请选择" v-model="moreSettingForm.overview_fields[key]">
                                            <el-option
                                                    :disabled="item ==  fields.field_key ? false : moreSettingForm.overview_fields.includes(fields.field_key) ? true : false"
                                                    :key="fields.field_key"
                                                    :label="fields.p_field_key == 'control_rest' ? '请假控件组.' +fields.field_name :
                                                          fields.p_field_key == 'control_overtime' ? '加班控件组.'+fields.field_name :
                                                          fields.p_field_key == 'control_travel' ? '出差控件组.'+fields.field_name :
                                                          fields.p_field_key == 'control_payable' ? '应付控件组.'+fields.field_name :
                                                          fields.field_name"
                                                    :value="fields.field_key"
                                                    @click.native="handleSelectOverviewFields(item,moreSettingForm.overview_fields.includes(fields.field_key),fields,key)"
                                                    v-for="fields in overviewFields">
                                            </el-option>
                                    </el-select>
                                    <i @click="handleClickDelField(key)" class="el-icon-remove"></i>
                                </li>
                            </draggable>
                        </ul>
                    </el-form-item>
                </div>
                <template v-if="approvalType == '' || approvalType == 'order_add' || approvalType == 'order_purchase' || approvalType == 'order_after_sale' || approvalType == 'quotation_add'  || approvalType == 'workorder_create' || approvalType == 'workorder_finish' || approvalType == 'workorder_travel' ">
                    <div class="add_overview_fields_btn" @click="handleClickAddField()"  v-if="moreSettingForm.overview_fields==undefined || moreSettingForm.overview_fields.length<3">
                        <i class="el-icon-plus"></i> 添加字段
                    </div>
                </template>



            </el-form>
        </div>
    </div>

</template>
<script>
import draggable from "vuedraggable";
export default {
    name: "moreSettings",
    components: {
        draggable
    },
     props: {
         approvalType: {
             type: String,
             default: ''
         },
        fieldList: {
            type: Array,
            default: () => []
        },
        more_setting: {
           type: Object,
           default: () => {}
        },
    },
    data() {
        return {
            id: '',
            moreSettingForm: {
                allow_undo_pending: 0,//允许撤销审批中的申请
                allow_substitute:0, //允许代他人提交
                allow_batch_processing: 0, //允许审批人批量处理
                enable_quick_approval: 0, //开启快捷审批
                approver_duplication_type: "", //审批人去重
                overview_fields: [],//设置的概览字段
            },
            overviewFields: [], //可以设置的概览字段
            moreSettingFormRules: {},
            data:[],
            disabled_allow_undo_pending:['order_add','order_purchase','order_after_sale','purchase','purchase_return','workorder_create'],
        }
    },
    mounted() {

    },
    created() {

        if(this.approvalType && this.disabled_allow_undo_pending.indexOf(this.approvalType) > -1){
            this.moreSettingForm.allow_undo_pending = 1
        }
        if(this.more_setting && this.more_setting.id){
            this.getMoreSettingForm(this.more_setting)
        }
    },
    methods: {
        getMoreSettingForm(info){
            let data = JSON.parse(JSON.stringify(info))
            this.$nextTick(()=>{
                this.moreSettingForm.allow_undo_pending = data.allow_undo_pending
                this.moreSettingForm.allow_substitute = data.allow_substitute
                this.moreSettingForm.allow_batch_processing = data.allow_batch_processing
                this.moreSettingForm.enable_quick_approval = data.enable_quick_approval
                this.moreSettingForm.approver_duplication_type = data.approver_duplication_type
                this.moreSettingForm.overview_fields = JSON.parse(JSON.stringify(data.overview_fields))
            })

        },
        // 获取概览区字段
        getOverviewFields(fieldList = []){
            let allFieldList = JSON.parse(JSON.stringify(fieldList))
            if(this.approvalType == 'order_add'){
                allFieldList = []
                fieldList.forEach((item, key) => {
                    if(item._child){
                        item._child.forEach((child, index) => {
                            if(child.field_type == 'radio_customer' || child.field_type == 'customer_contact'){
                                allFieldList.push(child)
                            }
                        })
                    }
                })
            }
            let overviewFields = []

            allFieldList.forEach((item, key) => {
                // 多行文本、说明、定位、明细/表格、图片、附件、关联审批单,行程组,发票  不能
                if (item.field_type != 'textarea' && item.field_type != 'explain' && item.field_type != 'location' && item.field_type != 'table' &&
                        item.field_type != 'image' && item.field_type != 'file' && item.field_type != 'relate_approve_form' &&  item.field_type != 'invoice' && item.field_type != 'goods'  && item.field_type != 'checkbox_approval'  && item.field_type != 'checkbox_check_record') {
                    if (item.field_type == 'control') {
                        item._child.forEach((child, index) => {
                            if (child.field_type != 'textarea' && child.field_type != 'file' && child.field_type != 'pk' && child.field_type != 'control_group' && child.field_key != 'stock_movement_product_info_form' && child.field_key != 'stock_movement_repository_scope' && child.field_key != 'reimbursement_various_type_amount') {
                                let json = {
                                    field_id: child.field_id,
                                    field_key: child.field_key,
                                    field_name: child.field_name,
                                    field_type: child.field_type,
                                    p_field_key: child.p_field_key,
                                }
                                if (child.field_key == 'stock_movement_product_total_amount') {
                                    if (child.initial_display == false) {
                                        overviewFields.push(json)
                                    }
                                } else {
                                    overviewFields.push(json)
                                }
                            }
                        })
                    } else {
                        let json = {
                            field_id: item.field_id,
                            field_key: item.field_key,
                            field_name: item.field_name,
                            field_type: item.field_type,
                            p_field_key: item.p_field_key,
                        }
                        overviewFields.push(json)
                    }

                }
            })
            this.overviewFields = JSON.parse(JSON.stringify(overviewFields))
            // 表单中字段删除后 对应的概览区字段设置中的也要删除
            if (this.moreSettingForm.overview_fields) {
                this.moreSettingForm.overview_fields = this.moreSettingForm.overview_fields.filter((item) => {
                    return this.overviewFields.some((obj) => obj.field_key === item);
                });
            }
        },
        // 添加概览区字段
        handleClickAddField(){
            this.getOverviewFields(this.fieldList)
            this.moreSettingForm.overview_fields.push('')
            this.haveEditedBefore()
        },

        // 删除概览区字段
        handleClickDelField(key){
            this.moreSettingForm.overview_fields.splice(key,1)
            this.haveEditedBefore()
        },

        // 选择字段
        handleSelectOverviewFields(item, flag, fields, key) {
           if (item != fields && flag == false) {
               this.$set(this.moreSettingForm.overview_fields, key, fields.field_key)
           }
            this.haveEditedBefore()
        },

        // 是否编辑了
        haveEditedBefore(){
            this.$emit('editSuccess', true)
        },

    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/approval.scss";
</style>
